/*
 * MDB shim for MDBModalHeader
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 */

import MUIDialogTitle from "@mui/material/DialogTitle";

export default function MDBModalHeader({ children, title, toggle, ...rest }) {
  return (
    <MUIDialogTitle {...rest} onClick={toggle}>
      {title ?? children}
    </MUIDialogTitle>
  );
}
